import React from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import MUIDataTable from "mui-datatables";
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import EditIcon from '@material-ui/icons/Edit';
import AddIcon from '@material-ui/icons/Add';
import red from '@material-ui/core/colors/red';
import Tooltip from '@material-ui/core/Tooltip';

import NestedList from 'components/NestedList/NestedList.jsx';
import AddressableForm from 'components/Forms/AddressablesForm.jsx';

import Api from 'services/api';
import { apiKey, refreshToken, APIRoot } from 'variables/authentication.jsx';

const modes = {
  EDIT: 'edit',
  NEW: 'new',
  VIEW: 'view'
}

function getMuiTheme() {
  return createMuiTheme({
    overrides: {
      MUIDataTableHeadCell: {

      },
      MUIDataTableBodyCell: {

      }
    },
    palette: {
      secondary: red
    },
  })
}

class AddressablesTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tableData: [],
      rawData: [],
      mode: modes.VIEW,
      selected_data: {
        "addressables": []
      }
    };

    this.ReloadData = this.ReloadData.bind(this);
    this.switchMode = this.switchMode.bind(this);
    this.getMode = this.getMode.bind(this);
    this.ReloadData();

    this.options = {
      selectableRows: 'none',
      print: false,
      download: false
    };

    this.state.columns = [
      {
        name: "Action",
        options: {
          customBodyRender: (value, tableMeta, updateValue) => {
            return (
              <IconButton onClick={this.startEdit(tableMeta.rowIndex)}>
                <EditIcon />
              </IconButton>
            );
          },
          filter: false,
          sort: false
        }
      },
      {
        name: 'id',
        label: 'ID',
        options: {
        }
      },
      {
        name: 'engine_version',
        label: 'Engine Version',
        options: {
        }
      },
      {
        name: 'device_type',
        label: 'Device Type',
        options: {
        }
      },
      // {
      //   name: 'path',
      //   label: 'Path',
      //   options: {
      //     // customBodyRender: (value, tableMeta, updateValue) => {
      //     //   //console.log(this.state.rawData)
      //     //   //console.log(this.state.rawData[tableMeta.rowIndex])
      //     //   return (
      //     //     <NestedList value={value} tableMeta={this.state.rawData[tableMeta.rowIndex]} />
      //     //   );
      //     // },
      //     // filter: false,
      //     // sort: false,
      //   }
      // },
      {
        name: 'path',
        label: 'Path',
        options: {
        }
      },
      {
        name: 'catalog_file',
        label: 'Catalog File',
        options: {
        }
      },
      {
        name: 'created_at',
        label: 'Created At',
        options: {
        }
      },
      {
        name: 'updated_at',
        label: 'Updated At',
        options: {
        }
      }
    ];
  }

  switchMode(target_mode, reload = false) {
    this.setState({ mode: target_mode });
    if (reload == true)
      this.ReloadData();
  }

  getMode() {
    return this.state.mode;
  }

  startEdit = rowNum => _ => {

    this.setState({ selected_data: this.state.rawData[rowNum] });
    this.switchMode(modes.EDIT);
  }

  newUpload = _ => {
    this.switchMode(modes.NEW);
  }

  async ReloadData() {
    try {
      const responseData = await Api({
        endpoint: '/v4/addressables'
      })

      if (!responseData || responseData == true) return;
      this.setState({ rawData: responseData })

      const tableData = responseData;

      this.setState({ tableData });
    } catch (e) {
      console.error(e)
    }
  }

  render() {
    if (this.state.mode == modes.VIEW) {
      return (
        <MuiThemeProvider theme={getMuiTheme()}>
          <div
            style={{
              textAlign: 'right'
            }}
          >
            <Button
              onClick={this.newUpload}
              variant="contained"
              color="primary"
              style={{
                margin: '0 1em 1em 1em'
              }}
            >
              Upload
            </Button>
          </div>
          <MUIDataTable
            columns={this.state.columns}
            data={this.state.tableData}
            options={this.options}
          />
        </MuiThemeProvider>
      );
    }
    return (
      <MuiThemeProvider theme={getMuiTheme()}>
        <AddressableForm switchMode={this.switchMode}
          getMode={this.getMode}
          row_data={this.state.selected_data}>
        </AddressableForm>
      </MuiThemeProvider>
    )
  }
}

export default AddressablesTable;
